import type { IDropdownItemTypeDivProps } from './DropdownItemTypeDiv'

import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { MEDIA } from 'vars/media'
import { DropdownItemColumnGap } from '../DropdownItem.h'

export const DropdownItemTypeDivStyled = styled.div<
  IDropdownItemTypeDivProps & { selected: boolean }
>`
  display: flex;
  align-items: center;
  width: ${({ width }) => width || 'auto'};
  height: ${({ height }) => (height ? `${height}%` : 'auto')};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
  column-gap: ${({ columnGap }) =>
    `var(${columnGap || DropdownItemColumnGap.INDENT_0})`};
  background-color: ${({
    selected,
    backgroundSelectedDefault,
    backgroundDefault,
    disabled,
    backgroundDisabledDefault,
  }) =>
    disabled
      ? `var(${backgroundDisabledDefault})`
      : selected
        ? `var(${backgroundSelectedDefault})`
        : `var(${backgroundDefault})`};
  font: ${({ font }) => `var(${font})`};
  box-sizing: border-box;
  border: none;

  ${TextBoxSC} {
    color: ${({
      selected,
      disabled,
      colorDefault,
      colorSelected,
      colorDisabled,
    }) =>
      disabled
        ? `var(${colorDisabled})`
        : selected
          ? `var(${colorSelected})`
          : `var(${colorDefault})`};
  }

  ${MEDIA.NO_TOUCH} {
    &:hover {
      background-color: ${({ backgroundHovered }) =>
        `var(${backgroundHovered})`};
      cursor: pointer;

      ${TextBoxSC} {
        color: ${({ selected, colorSelected, colorHovered }) =>
          selected ? `var(${colorSelected})` : `var(${colorHovered})`};
      }
    }
  }

  &:active {
    background-color: ${({ backgroundPressed }) => `var(${backgroundPressed})`};

    ${TextBoxSC} {
      color: ${({ selected, colorSelected, colorPressed }) =>
        selected ? `var(${colorSelected})` : `var(${colorPressed})`};
    }
  }
`
